(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
  /* Rotating relationship word.
     ONE interval, keyed to Date.now(), so a backgrounded tab resumes on the
     correct word instead of freezing mid-fade on a blank one. Every word is
     already in the DOM — this only moves the `is-on` class, so the slot's
     width never changes and the headline never reflows.
     prefers-reduced-motion: freeze on the LAST word, which is the universal one. */
  (function () {
    var HOLD = 1500, HOLD_LAST = 4000, FADE = 220;

    function init(root) {
      var host = root.querySelector('[data-sb-rot]');
      if (!host) return;
      var items = host.querySelectorAll('[data-sb-rot-item]');
      var n = items.length;
      if (n < 2) return;

      function show(i) {
        for (var k = 0; k < n; k++) { items[k].classList.toggle('is-on', k === i); }
      }
      function hideAll() {
        for (var k = 0; k < n; k++) { items[k].classList.remove('is-on'); }
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduce && reduce.matches) { show(n - 1); return; }

      var cycle = (n - 1) * HOLD + HOLD_LAST;
      var t0 = Date.now();
      var last = -1, lastVis = null;

      function tick() {
        var t = (Date.now() - t0) % cycle, i = 0;
        while (i < n - 1 && t >= HOLD) { t -= HOLD; i++; }
        var len = i === n - 1 ? HOLD_LAST : HOLD;
        var vis = t < len - FADE;
        if (i !== last) { last = i; if (vis) show(i); }
        if (vis !== lastVis) { if (vis) { show(last); } else { hideAll(); } lastVis = vis; }
      }

      show(0);
      tick();
      setInterval(tick, 100);
    }

    /* Mobile sticky bar — reveal once the hero CTA has scrolled out of view,
       so it never sits under the button it duplicates. */
    function sticky(root) {
      var bar = root.querySelector('[data-sb-sticky]');
      var cta = root.querySelector('.sb-hero__ctas');
      if (!bar || !cta) return;
      if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { bar.removeAttribute('data-sb-show'); }
          else if (en.boundingClientRect.top < 0) { bar.setAttribute('data-sb-show', ''); }
          else { bar.removeAttribute('data-sb-show'); }
        });
      }, { threshold: 0 }).observe(cta);
    }

    /* prefers-reduced-motion: hold the poster frame. CSS can't pause a video,
       and a looping hero is exactly the motion this setting asks us to stop. */
    function stillFootage(root) {
      var v = root.querySelector('[data-sb-hero-video]');
      if (!v) return;
      var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!mq || !mq.matches) return;
      v.removeAttribute('autoplay');
      v.autoplay = false;
      try { v.pause(); } catch (e) {}
    }

    function boot(root) { init(root); sticky(root); stillFootage(root); }

    document.querySelectorAll('.sb-hero').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.sb-hero')) boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  function slugify(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function toRoman(n) {
    var map = [[10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']], out = '';
    for (var i = 0; i < map.length; i++) {
      while (n >= map[i][0]) { out += map[i][1]; n -= map[i][0]; }
    }
    return out;
  }

  function init() {
    var content = document.querySelector('.art-content');
    if (!content) return;
    var headings = content.querySelectorAll('h2');

    // Relocate the inline CTA to just before the Nth H2 (progressive enhancement).
    var cta = document.getElementById('art-inline-cta');
    if (cta && headings.length) {
      var after = parseInt(cta.getAttribute('data-after'), 10);
      if (!after || after < 1) after = 2;
      if (headings.length >= after) {
        headings[after - 1].insertAdjacentElement('beforebegin', cta);
      }
    }

    // Build the Contents from the H2s — roman numeral + period, title, dot leader.
    var aside = document.getElementById('art-toc');
    var list = document.getElementById('art-toc-list');
    var layout = document.getElementById('art-layout');
    if (!aside || !list || headings.length < 2) {
      if (aside) aside.parentNode.removeChild(aside);
    } else {
      var anchors = [];
      var seen = {};
      Array.prototype.forEach.call(headings, function (h, i) {
        var id = h.id;
        if (!id) {
          id = slugify(h.textContent) || 'section-' + (i + 1);
          if (seen[id]) id = id + '-' + (i + 1);
          h.id = id;
        }
        seen[id] = true;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        var num = document.createElement('span');
        num.className = 'art-toc-n';
        num.textContent = toRoman(i + 1) + '.';
        var txt = document.createElement('span');
        txt.className = 'art-toc-t';
        txt.textContent = h.textContent;
        var ldr = document.createElement('span');
        ldr.className = 'art-toc-ldr';
        a.appendChild(num);
        a.appendChild(txt);
        a.appendChild(ldr);
        li.appendChild(a);
        list.appendChild(li);
        anchors.push(a);
      });

      aside.hidden = false;
      if (layout) layout.classList.add('art-layout--toc');

      // Scroll-spy: highlight the section currently in view.
      if ('IntersectionObserver' in window) {
        var byId = {};
        anchors.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              anchors.forEach(function (a) { a.classList.remove('is-active'); });
              var match = byId[e.target.id];
              if (match) match.classList.add('is-active');
            }
          });
        }, { rootMargin: '-12% 0px -70% 0px' });
        Array.prototype.forEach.call(headings, function (h) { obs.observe(h); });
      }
    }

    // Reading-progress bar (the sticky TOC needs no JS to show/hide).
    var bar = document.querySelector('.art-progress');
    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, doc.scrollTop / max)) : 0;
      if (bar) bar.style.width = (p * 100) + '%';
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    // Exit-intent offer: desktop pointers only, armed after 6s, once per visitor.
    // Never fires on load — mouseout at the viewport top is the only trigger.
    var exit = document.querySelector('[data-exit]');
    if (exit && window.matchMedia('(min-width: 1000px) and (pointer: fine)').matches) {
      var KEY = 'sb_exit_seen';
      var armed = false;
      var seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
      setTimeout(function () { armed = true; }, 6000);
      function showExit() {
        if (seen || !armed) return;
        seen = true;
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        exit.hidden = false;
      }
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) showExit();
      });
      exit.addEventListener('click', function (e) { if (e.target === exit) exit.hidden = true; });
      Array.prototype.forEach.call(exit.querySelectorAll('[data-exit-close]'), function (b) {
        b.addEventListener('click', function () { exit.hidden = true; });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') exit.hidden = true; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  /* --sb-cartf-h: the pinned bar's real height, so the cart above can reserve
     exactly that much and nothing hides underneath. Re-measured on resize and
     whenever the cart re-renders (the wallet buttons change its height). */
  (function () {
    if (window.__sbCartFootH) return;
    window.__sbCartFootH = true;
    function fit() {
      var f = document.querySelector('.sb-cartf');
      var h = f && getComputedStyle(f).display !== 'none' ? Math.ceil(f.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--sb-cartf-h', h + 'px');
    }
    function watch() {
      var host = document.querySelector('#main-cart-footer');
      if (!host || !('MutationObserver' in window)) return;
      new MutationObserver(function () { setTimeout(fit, 30); }).observe(host, { childList: true, subtree: true });
    }
    function start() { fit(); watch(); setTimeout(fit, 400); setTimeout(fit, 1500); }
    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('resize', fit);
    window.addEventListener('orientationchange', fit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  /* sb-cart — delivery choice (Standard / Express) and the instrumental row.
     Express and instrumental are real line items, added / removed with the
     cart API and the Section Rendering API, same pattern as cart-addon-upsell.
     Times: nearest hour on the visitor's clock. */
  (function () {
    if (window.__sbCartV4) return; window.__sbCartV4 = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var SECTIONS = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];

    function times() {
      if (!window.sbEta) return;
      var whens = document.querySelectorAll('[data-sb-when]');
      if (!whens.length) {
        /* Express is off, so there is no Standard/Express choice to read —
           the song row still shows the standard promise on the buyer's clock. */
        document.querySelectorAll('[data-sb-ready]').forEach(function (r) {
          var e = window.sbEta(parseFloat(r.getAttribute('data-h') || '24'));
          r.textContent = e.word + (e.time ? ', ' + e.time : '');
        });
        return;
      }
      whens.forEach(function (f) {
        var sh = parseFloat(f.getAttribute('data-standard-hours') || '24'), eh = parseFloat(f.getAttribute('data-express-hours') || '1');
        var std = window.sbEta(sh), ex = window.sbEta(eh);
        var sd = f.querySelector('[data-sb-day="standard"]'), st = f.querySelector('[data-sb-time="standard"]');
        var ed = f.querySelector('[data-sb-day="express"]'), et = f.querySelector('[data-sb-time="express"]');
        if (sd) sd.textContent = std.word; if (st) st.textContent = std.time;
        if (ed) ed.textContent = ex.word; if (et) et.textContent = ex.time;
        /* the song row's "Ready …" follows whichever delivery is on */
        var onEx = !!f.querySelector('[data-sb-opt="express"].is-on'), pick = onEx ? ex : std;
        document.querySelectorAll('[data-sb-ready]').forEach(function (r) { r.textContent = pick.word + (pick.time ? ', ' + pick.time : ''); });
      });
    }

    function swap(sel, html, src) {
      if (!html) return;
      var dest = document.querySelector(sel), n = new DOMParser().parseFromString(html, 'text/html').querySelector(src);
      if (dest && n) dest.innerHTML = n.innerHTML;
    }
    function rerender(res) {
      if (!res || !res.sections) return;
      swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
      swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
      var b = document.getElementById('cart-icon-bubble');
      if (b && res.sections['cart-icon-bubble']) { var nb = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (nb) b.innerHTML = nb.innerHTML; }
      times();
    }
    function post(path, body) {
      body.sections = SECTIONS; body.sections_url = window.location.pathname;
      return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
    }
    function lineKeyFor(sku) {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var it = (c.items || []).filter(function (i) { return i.sku === sku; })[0]; return it ? it.key : null;
      });
    }
    function setAddon(sku, variantId, on, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      var p = on
        ? post('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
        : lineKeyFor(sku).then(function (key) { return key ? post('cart/change.js', { id: key, quantity: 0 }) : null; });
      p.then(rerender).catch(function () {}).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    function setQty(key, qty, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      post('cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(rerender).catch(function () {}).then(function () { if (btn) btn.removeAttribute('aria-busy'); fixSongs(); });
    }
    // A song is one of a kind: if a line with a brief ever carries quantity > 1
    // (two identical adds merged), put it back to 1.
    var fixing = false;
    function fixSongs() {
      var el = document.querySelector('[data-sb-qty-fix]');
      if (!el || fixing) return;
      fixing = true;
      post('cart/change.js', { id: el.getAttribute('data-sb-qty-fix'), quantity: 1 }).then(rerender).catch(function () {}).then(function () { fixing = false; if (document.querySelector('[data-sb-qty-fix]')) fixSongs(); });
    }

    /* ADR-085 — keepsakes live inside the song's card */
    function addKeep(variantId, forName, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      var props = forName ? { 'For': forName } : {};
      post('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props }] }).then(rerender).catch(function () {}).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }
    function removeKeep(key, btn) {
      if (btn) btn.setAttribute('aria-busy', 'true');
      post('cart/change.js', { id: key, quantity: 0 }).then(rerender).catch(function () {});
    }
    /* engraving — merged into the Soundbox line's properties, saved on change */
    var engTimer = null;
    function saveEngraving(form) {
      var key = form.getAttribute('data-sb-engrave'); if (!key) return;
      var fields = {};
      form.querySelectorAll('input[name]').forEach(function (i) { fields[i.name] = i.value.replace(/\s+/g, ' ').trim(); });
      form.setAttribute('aria-busy', 'true');
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var line = (c.items || []).filter(function (i) { return i.key === key; })[0]; if (!line) return null;
        var props = {}; Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
        Object.keys(fields).forEach(function (k) { if (fields[k]) props[k] = fields[k]; else delete props[k]; });
        return post('cart/change.js', { id: key, quantity: line.quantity, properties: props });
      }).then(function (res) {
        /* re-render only if the visitor has left the fields — never under a caret */
        var active = document.activeElement, inside = active && form.contains(active);
        if (res && !inside) rerender(res); else form.removeAttribute('aria-busy');
        if (res && inside) { form.__sbPending = res; }
      }).catch(function () { form.removeAttribute('aria-busy'); });
    }
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('[data-sb-engrave]');
      if (!form) return;
      clearTimeout(engTimer); engTimer = setTimeout(function () { saveEngraving(form); }, 150);
    });
    document.addEventListener('focusout', function (e) {
      var form = e.target.closest && e.target.closest('[data-sb-engrave]');
      if (!form || !form.__sbPending) return;
      setTimeout(function () { if (!form.contains(document.activeElement)) { var r = form.__sbPending; form.__sbPending = null; rerender(r); } }, 80);
    });

    document.addEventListener('click', function (e) {
      var ak = e.target.closest && e.target.closest('[data-sb-add-keep]');
      if (ak) {
        e.preventDefault();
        if (ak.getAttribute('aria-busy') === 'true') return;
        var wrap = ak.closest('[data-sb-keeps]');
        addKeep(ak.getAttribute('data-sb-add-keep'), wrap ? wrap.getAttribute('data-for') : '', ak);
        return;
      }
      var rk = e.target.closest && e.target.closest('[data-sb-remove]');
      if (rk) { e.preventDefault(); removeKeep(rk.getAttribute('data-sb-remove'), rk); return; }
      var st = e.target.closest && e.target.closest('[data-sb-qty]');
      if (st) {
        e.preventDefault();
        var wrap = st.closest('[data-sb-stepper]');
        if (wrap) setQty(wrap.getAttribute('data-sb-stepper'), parseInt(st.getAttribute('data-sb-qty'), 10) || 0, st);
        return;
      }
      var opt = e.target.closest && e.target.closest('[data-sb-opt]');
      if (opt) {
        e.preventDefault();
        if (opt.classList.contains('is-on') || opt.getAttribute('aria-busy') === 'true') return;
        var f = opt.closest('[data-sb-when]'), exId = f && f.getAttribute('data-express-id');
        setAddon('EXSHIP', exId, opt.getAttribute('data-sb-opt') === 'express', opt);
        return;
      }
      var row = e.target.closest && e.target.closest('[data-sb-inst]');
      if (row) {
        e.preventDefault();
        if (row.getAttribute('aria-busy') === 'true') return;
        setAddon('INSTRUMENTALSONG', row.getAttribute('data-variant-id'), !row.classList.contains('is-on'), row);
      }
    });

    times(); setInterval(times, 60000); fixSongs();
    document.addEventListener('shopify:section:load', times);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collab"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.clb').forEach(function (root) {
      if (root.__clbWired) return;
      root.__clbWired = true;

      [].slice.call(root.querySelectorAll('.clb-card')).forEach(function (card) {
        var a = card.querySelector('[data-clb-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-clb-play]');
        var prog = card.querySelector('.clb-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });

      var sticky = root.querySelector('[data-clb-sticky]');
      var heroCtas = root.querySelector('[data-clb-heroctas]');
      if (sticky && heroCtas && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', !entry.isIntersecting && below);
          });
        }, { threshold: 0 }).observe(heroCtas);
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-song"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;
      var sbId=d.sbId, sbCents=parseInt(d.sbCents,10)||0;
      var paId=d.paId, paCents=parseInt(d.paCents,10)||0;
      // The intent product page's chosen offer, handed over by the quiz.
      function wantedOffer(){
        var fromUrl='';
        try{ var o=new URLSearchParams(window.location.search).get('offer'); if(o==='song-soundbox'||o==='song-plaque'||o==='song') fromUrl=o; }catch(e){}
        try{ return fromUrl || sessionStorage.getItem('sbq_offer') || ''; }catch(e){ return fromUrl; }
      }
      function clearOffer(){ try{ sessionStorage.removeItem('sbq_offer'); }catch(e){} }

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var sbCb=cs.querySelector('[data-add="sb"]'), sbRow=cs.querySelector('[data-sbrow]');
      var engWrap=cs.querySelector('[data-engrave]'), engIn=cs.querySelector('[data-engrave-in]'), engCount=cs.querySelector('[data-engrave-count]');
      function engraving(){ return engIn && sbCb && sbCb.checked ? engIn.value.replace(/\s+/g,' ').trim().slice(0,40) : ''; }
      if(engIn && engCount){ engIn.addEventListener('input', function(){ engCount.textContent=String(engIn.value.length); }); }
      // Arriving from an intent page with the bundle chosen pre-checks the box.
      // It stays a checkbox: the visitor can still change their mind here, which
      // is the whole reason the product page does not add to cart itself.
      if(sbCb && wantedOffer()==='song-soundbox') sbCb.checked=true;
      var paCb=cs.querySelector('[data-add="pa"]'), paRow=cs.querySelector('[data-parow]');
      if(paCb && wantedOffer()==='song-plaque') paCb.checked=true;
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(sbCb&&sbCb.checked){ t+=sbCents; if(sbRow) sbRow.hidden=false; if(engWrap) engWrap.hidden=false; } else { if(sbRow) sbRow.hidden=true; if(engWrap) engWrap.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        if(paCb&&paCb.checked){ t+=paCents; if(paRow) paRow.hidden=false; } else if(paRow){ paRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(sbCb) sbCb.addEventListener('change',recalc);
      if(paCb) paCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);
      recalc();

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEls=cs.querySelectorAll('[data-error]');
      var errEl=errEls[0]||null; // kept for the re-enable path below
      function showErr(m){
        var scrolled=false;
        errEls.forEach(function(el){
          el.textContent=m; el.hidden=false;
          // scroll to the first VISIBLE error (the quiz card's, when the rail is hidden)
          if(!scrolled && el.offsetParent!==null){ scrolled=true; try{ el.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} }
        });
      }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      // One song per brief (Ajinkya, 2026-09-02: "same custom song ordered twice
      // doesn't make sense"). Adding replaces any SONG line already in the cart —
      // this product, or any of the 175 occasion products that carry the same brief
      // (ADR-082: a line with a Recipient property is a song) — unless the quiz was
      // opened with ?another=1 (sessionStorage sbq_another), which adds a second song.
      // Either way a song line never ends up with quantity > 1.
      var productId=d.productId;
      function jsonPost(path, body){ return fetch(path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}); }
      function wantAnother(){ try{ return sessionStorage.getItem('sbq_another')==='1'; }catch(e){ return false; } }
      function clearAnother(){ try{ sessionStorage.removeItem('sbq_another'); }catch(e){} }
      function replaceExisting(){
        if(!productId || wantAnother()) return Promise.resolve();
        return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){
          var updates={}, any=false;
          // One song per cart — and the add-ons that rode with the old song go
          // with it, or a re-submit leaves a second Soundbox in the cart.
          var addonIds=[exId,inId,plId,sbId,paId].filter(Boolean).map(String);
          function isSong(i){ var p=i.properties||{}; return String(i.product_id)===String(productId) || !!(p['Recipient Name']||p['Recipient']); }
          (c.items||[]).forEach(function(i){
            if(isSong(i) || addonIds.indexOf(String(i.variant_id))!==-1){ updates[i.key]=0; any=true; }
          });
          return any ? jsonPost('/cart/update.js',{updates:updates}) : null;
        }).catch(function(){});
      }
      function capToOne(added){
        if(!added || !added.key || !(added.quantity>1)) return Promise.resolve();
        return jsonPost('/cart/change.js',{id:added.key,quantity:1}).catch(function(){});
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        // No Soundbox variant to sell yet, but the visitor asked for the bundle
        // on the intent page. Record it on the line rather than lose it.
        if(!sbId && wantedOffer()==='song-soundbox') props['Keepsake interest'] = 'Soundbox';
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        replaceExisting().then(function(){
          return fetch('/cart/add.js',{method:'POST',body:fd});
        }).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(capToOne).then(function(){
          clearAnother();
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(sbCb&&sbCb.checked&&sbId){
            var sbProps={};
            var eng=engraving(); if(eng) sbProps['Engraving']=eng;
            if(props['Recipient Name']) sbProps['For']=props['Recipient Name'];
            items.push({id:sbId,quantity:1,properties:sbProps});
          }
          if(paCb&&paCb.checked&&paId){
            var paProps={}; if(props['Recipient Name']) paProps['For']=props['Recipient Name'];
            items.push({id:paId,quantity:1,properties:paProps});
          }
          clearOffer();
          // THE SONG IS ALREADY IN THE CART BY NOW. If an add-on fails — a
          // variant went draft or sold out, the id is stale — swallow it and
          // carry on to the cart. Throwing here used to surface "something
          // went wrong" over an order that had actually succeeded, and the
          // buyer would add the song a second time. The cart shows exactly
          // what is in it; a missing add-on is visible and recoverable there.
          if(!items.length) return;
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .catch(function(){});
        }).then(function(){ window.location.href=(cs&&cs.getAttribute('data-after-add'))||'/cart'; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-editorial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      var baseNameEl=cs.querySelector('[data-base-name]'), basePriceEl=cs.querySelector('[data-base-price]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);

      // Keepsake single-select (the .cs-hold band). Each card is a full-price
      // variant ("song in [form]"), so choosing one SETS the base cart line —
      // it is not an add-on. The buy-box base row + total follow the choice.
      var kkCards=cs.querySelectorAll('[data-kv]'), selName='';
      function selectKeepsake(card){
        if(!card) return;
        baseId=card.getAttribute('data-vid');
        baseCents=parseInt(card.getAttribute('data-vcents'),10)||baseCents;
        selName=card.getAttribute('data-vname')||'';
        kkCards.forEach(function(c){ var on=(c===card); c.classList.toggle('on',on); c.setAttribute('aria-checked',on?'true':'false'); });
        if(baseNameEl) baseNameEl.textContent=selName;
        if(basePriceEl) basePriceEl.textContent=money(baseCents);
        recalc();
      }
      kkCards.forEach(function(card){ card.addEventListener('click',function(){ selectKeepsake(card); }); });
      // Sync the buy box to the pre-selected card (the product's default variant).
      var onCard=cs.querySelector('[data-kv].on')||kkCards[0];
      if(onCard){ selectKeepsake(onCard); } else { recalc(); }

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEl=cs.querySelector('[data-error]');
      function showErr(m){ if(errEl){ errEl.textContent=m; errEl.hidden=false; try{ errEl.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} } }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(function(){
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(items.length){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}); }
        }).then(function(){ window.location.href='/checkout'; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-plaque"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kp').forEach(function(kp){
      var mainImg = kp.querySelector('.kp-main-img');
      var thumbs = kp.querySelectorAll('.kp-thumb');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var full = t.getAttribute('data-full');
          if (mainImg && full) { mainImg.src = full; }
          thumbs.forEach(function(x){ x.classList.remove('on'); });
          t.classList.add('on');
        });
      });

      var plaqueVid = kp.getAttribute('data-variant-id');
      var songVid = kp.getAttribute('data-song-vid');
      var soloVid = kp.getAttribute('data-songonly-vid');
      var cta = kp.querySelector('[data-cta]');
      var mode = 'song';
      var ctaLabel = { song: 'Create your song + plaque →', plaque: 'Personalize your plaque →', solo: 'Create your song →' };
      var promiseEl = kp.querySelector('[data-promise]');
      var shipPromise = promiseEl ? promiseEl.innerHTML : '';
      var promiseHTML = {
        song: shipPromise,
        plaque: shipPromise,
        solo: '<b>Unlimited revisions</b> — we refine the song until you love it. Nothing ships; it’s digital.'
      };

      kp.querySelectorAll('.kp-opt').forEach(function(opt){
        opt.addEventListener('click', function(){
          mode = opt.getAttribute('data-opt');
          kp.querySelectorAll('.kp-opt').forEach(function(o){
            var on = o === opt;
            o.classList.toggle('on', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          kp.querySelectorAll('[data-whats]').forEach(function(w){ w.hidden = (w.getAttribute('data-whats') !== mode); });
          if (cta) { cta.textContent = ctaLabel[mode]; }
          if (promiseEl && promiseHTML[mode]) { promiseEl.innerHTML = promiseHTML[mode]; }
        });
      });

      var lastFocus = null;
      function openModal(m){
        if (!m) { return; }
        lastFocus = document.activeElement;
        m.hidden = false;
        document.body.style.overflow = 'hidden';
        var f = m.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(m){
        if (!m) { return; }
        m.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
      }
      kp.querySelectorAll('.kp-modal').forEach(function(m){
        m.querySelectorAll('[data-modal-close]').forEach(function(c){ c.addEventListener('click', function(){ closeModal(m); }); });
      });
      document.addEventListener('keydown', function(e){
        if (e.key !== 'Escape') { return; }
        kp.querySelectorAll('.kp-modal').forEach(function(m){ if (!m.hidden) { closeModal(m); } });
      });
      if (cta) {
        cta.addEventListener('click', function(){ openModal(kp.querySelector('[data-modal="' + mode + '"]')); });
      }

      function wireFile(input, wrapSel, labelSel){
        if (!input) { return function(){ return null; }; }
        var wrap = input.closest(wrapSel);
        var label = wrap ? wrap.querySelector(labelSel) : null;
        input.addEventListener('change', function(){
          if (input.files && input.files[0]) {
            if (label) { label.textContent = '✓ ' + input.files[0].name; }
            if (wrap) { wrap.classList.add('is-on'); }
          }
        });
        return function(){ return (input.files && input.files[0]) ? input.files[0] : null; };
      }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }
      function val(el){ return el ? (el.value || '').trim() : ''; }
      function collectProps(scope, attr){
        var out = {};
        scope.querySelectorAll('[' + attr + ']').forEach(function(el){ var v = val(el); if (v) { out[el.getAttribute(attr)] = v; } });
        return out;
      }

      var songModal = kp.querySelector('[data-modal="song"]');
      if (songModal) {
        var step1 = songModal.querySelector('[data-step="1"]');
        var step2 = songModal.querySelector('[data-step="2"]');
        var nextBtn = songModal.querySelector('[data-step-next]');
        var backBtn = songModal.querySelector('[data-step-back]');
        var err1 = songModal.querySelector('[data-error]');
        var err2 = songModal.querySelector('[data-error2]');
        var submitS = songModal.querySelector('[data-submit="song"]');
        var brief = songModal.querySelector('[data-song-brief]');
        var getPhotoS = wireFile(songModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');

        if (nextBtn) {
          nextBtn.addEventListener('click', function(){
            if (err1) { err1.hidden = true; }
            var msg = (brief && brief.sbBrief) ? brief.sbBrief.validate() : '';
            if (msg) { err1.textContent = msg; err1.hidden = false; return; }
            step1.hidden = true; step2.hidden = false;
          });
        }
        if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

        if (submitS) {
          submitS.addEventListener('click', function(){
            if (err2) { err2.hidden = true; }
            if (!brief || !brief.sbBrief) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; return; }
            var msg = brief.sbBrief.validate();
            if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
            var props = brief.sbBrief.collect();
            var p2 = collectProps(step2, 'data-pk');
            Object.keys(p2).forEach(function(k){ props[k] = p2[k]; });
            var voice = brief.sbBrief.getVoice();
            var orig = submitS.textContent;
            submitS.disabled = true; submitS.textContent = 'Adding…';
            addItem(songVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }, { key: 'Photo', file: getPhotoS() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitS.disabled = false; submitS.textContent = orig; err2.textContent = 'Something went wrong adding to cart. Please try again.'; err2.hidden = false; });
          });
        }
      }

      var plaqueModal = kp.querySelector('[data-modal="plaque"]');
      if (plaqueModal) {
        var errP = plaqueModal.querySelector('[data-error]');
        var submitP = plaqueModal.querySelector('[data-submit="plaque"]');
        var getPhotoP = wireFile(plaqueModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');
        if (submitP) {
          submitP.addEventListener('click', function(){
            if (errP) { errP.hidden = true; }
            var props = collectProps(plaqueModal, 'data-pk');
            var orig = submitP.textContent;
            submitP.disabled = true; submitP.textContent = 'Adding…';
            addItem(plaqueVid, props, [{ key: 'Photo', file: getPhotoP() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitP.disabled = false; submitP.textContent = orig; errP.textContent = 'Something went wrong adding to cart. Please try again.'; errP.hidden = false; });
          });
        }
      }

      var soloModal = kp.querySelector('[data-modal="solo"]');
      if (soloModal) {
        var errSolo = soloModal.querySelector('[data-error]');
        var submitSolo = soloModal.querySelector('[data-submit="solo"]');
        var briefSolo = soloModal.querySelector('[data-song-brief]');
        if (submitSolo) {
          submitSolo.addEventListener('click', function(){
            if (errSolo) { errSolo.hidden = true; }
            if (!briefSolo || !briefSolo.sbBrief) { errSolo.textContent = 'Something went wrong. Please refresh and try again.'; errSolo.hidden = false; return; }
            var msg = briefSolo.sbBrief.validate();
            if (msg) { errSolo.textContent = msg; errSolo.hidden = false; return; }
            var props = briefSolo.sbBrief.collect();
            var voice = briefSolo.sbBrief.getVoice();
            var orig = submitSolo.textContent;
            submitSolo.disabled = true; submitSolo.textContent = 'Adding…';
            addItem(soloVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitSolo.disabled = false; submitSolo.textContent = orig; errSolo.textContent = 'Something went wrong adding to cart. Please try again.'; errSolo.hidden = false; });
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-occasion-keepsake"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.ok').forEach(function(ok){
      var mainImg = ok.querySelector('.ok-main-img');
      var stickyPrice = ok.querySelector('[data-sticky-price]');
      var ctaPrice = ok.querySelector('[data-cta-price]');
      var ptitle = ok.getAttribute('data-ptitle') || '';
      var origTitle = document.title;
      var titleTail = (ptitle && origTitle.indexOf(ptitle) === 0) ? origTitle.slice(ptitle.length) : '';
      var sel = { vid: null, name: '', price: '', personalize: false, photo: false };
      var cardList = Array.prototype.slice.call(ok.querySelectorAll('.ok-cc'));
      var slider = ok.querySelector('[data-slider]');
      var dotsWrap = ok.querySelector('[data-sldots]');
      var thumbs = Array.prototype.slice.call(ok.querySelectorAll('.ok-thumb'));
      var curIndex = 0, scrollLock = false, dots = [];

      function selectCard(card, fromUser){
        curIndex = cardList.indexOf(card);
        ok.querySelectorAll('.ok-cc').forEach(function(c){ c.classList.remove('on'); c.setAttribute('aria-selected','false'); });
        card.classList.add('on'); card.setAttribute('aria-selected','true');
        sel.vid = card.getAttribute('data-vid');
        if (thumbs.length) { thumbs.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-thumb-vid') === sel.vid); }); }
        sel.name = card.getAttribute('data-name');
        sel.price = card.getAttribute('data-price');
        if (stickyPrice) { stickyPrice.textContent = sel.price; }
        if (ctaPrice && sel.price) { ctaPrice.textContent = sel.price; }
        sel.personalize = card.getAttribute('data-personalize') === '1';
        sel.photo = card.getAttribute('data-photo') === '1';
        var img = card.getAttribute('data-img');
        if (mainImg && img) { mainImg.src = img; }
        if (fromUser) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', sel.vid); history.replaceState({}, '', u.toString()); } catch (e) {}
          if (ptitle && sel.name) { document.title = ptitle + ' — ' + sel.name + titleTail; }
        }
      }
      function paintDots(i){ dots.forEach(function(d, j){ d.classList.toggle('on', j === i); }); }
      function goToIndex(i, scroll){
        if (i < 0 || i >= cardList.length) { return; }
        if (scroll && slider) {
          scrollLock = true;
          slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
          setTimeout(function(){ scrollLock = false; }, 400);
        }
        paintDots(i);
        selectCard(cardList[i], true);
      }
      // dots — one per keepsake (supplementary control; the card grid is the accessible one)
      if (dotsWrap && cardList.length > 1) {
        cardList.forEach(function(_, i){
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'ok-sldot' + (i === 0 ? ' on' : '');
          d.setAttribute('tabindex', '-1'); d.setAttribute('aria-hidden', 'true');
          d.addEventListener('click', function(){ goToIndex(i, true); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      // tap a card → scroll the slider to it (and select)
      cardList.forEach(function(card, i){
        card.addEventListener('click', function(){ goToIndex(i, true); });
      });
      // click a desktop thumbnail → select the matching keepsake (swaps hero + grid + price + URL)
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var card = ok.querySelector('.ok-cc[data-vid="' + t.getAttribute('data-thumb-vid') + '"]');
          if (card) { goToIndex(cardList.indexOf(card), true); }
        });
      });
      // swipe the slider → select the matching card (guard against the programmatic scroll)
      if (slider) {
        var raf;
        slider.addEventListener('scroll', function(){
          if (scrollLock) { return; }
          if (raf) { cancelAnimationFrame(raf); }
          raf = requestAnimationFrame(function(){
            var i = Math.round(slider.scrollLeft / slider.clientWidth);
            if (i !== curIndex && cardList[i]) { paintDots(i); selectCard(cardList[i], true); }
          });
        });
      }
      var urlVar = null;
      try { urlVar = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
      var startCard = (urlVar && ok.querySelector('.ok-cc[data-vid="' + urlVar + '"]')) || ok.querySelector('.ok-cc.on') || ok.querySelector('.ok-cc');
      if (startCard) {
        selectCard(startCard, !!urlVar);
        var si = cardList.indexOf(startCard); if (si < 0) { si = 0; }
        if (slider) { slider.scrollLeft = si * slider.clientWidth; }
        paintDots(si);
      }

      // modal
      var modal = ok.querySelector('[data-modal]');
      var step1 = modal.querySelector('[data-step="1"]');
      var step2 = modal.querySelector('[data-step="2"]');
      var brief = modal.querySelector('[data-song-brief]');
      var pwrap = modal.querySelector('[data-pwrap]');
      var photoInput = modal.querySelector('[data-photo]');
      var plabel = modal.querySelector('[data-plabel]');
      var err1 = modal.querySelector('[data-err1]');
      var err2 = modal.querySelector('[data-err2]');
      var submitBtn = modal.querySelector('[data-submit]');
      var nextBtn = modal.querySelector('[data-next]');
      var lastFocus = null;

      function openModal(){
        lastFocus = document.activeElement;
        modal.hidden = false; document.body.style.overflow = 'hidden';
        step2.hidden = true; step1.hidden = false;
        if (nextBtn) { nextBtn.textContent = sel.personalize ? 'Next: make it yours →' : 'Continue to checkout →'; }
        var f = step1.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(){ modal.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) { lastFocus.focus(); } }
      ok.querySelectorAll('[data-open]').forEach(function(b){ b.addEventListener('click', openModal); });

      // sticky mobile CTA — reveal once the main button scrolls out of view
      var sticky = ok.querySelector('[data-sticky]');
      var primaryCta = ok.querySelector('.ok-buy > .ok-cta');
      if (sticky && primaryCta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){ sticky.classList.toggle('on', !e.isIntersecting); });
        }, { rootMargin: '0px 0px -45% 0px' }).observe(primaryCta);
      } else if (sticky) {
        sticky.classList.add('on');
      }
      modal.querySelectorAll('[data-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) { closeModal(); } });

      if (photoInput) {
        photoInput.addEventListener('change', function(){
          if (photoInput.files && photoInput.files[0]) {
            if (plabel) { plabel.textContent = '✓ ' + photoInput.files[0].name; }
            if (pwrap) { pwrap.classList.add('is-on'); }
          }
        });
      }

      function val(el){ return el ? (el.value || '').trim() : ''; }
      function briefOk(){ return brief && brief.sbBrief; }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(){
          if (err1) { err1.hidden = true; }
          var msg = briefOk() ? brief.sbBrief.validate() : '';
          if (msg) { if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          if (sel.personalize) {
            if (pwrap) { pwrap.hidden = !sel.photo; }
            step1.hidden = true; step2.hidden = false;
            var f2 = step2.querySelector('input, button'); if (f2) { f2.focus(); }
          } else {
            doAdd();
          }
        });
      }
      var backBtn = modal.querySelector('[data-back]');
      if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }

      function doAdd(){
        if (!briefOk()) { return; }
        var props = brief.sbBrief.collect();
        props['Keepsake'] = sel.name;
        if (sel.personalize) {
          step2.querySelectorAll('[data-pk]').forEach(function(el){ var v = val(el); if (v) { props[el.getAttribute('data-pk')] = v; } });
        }
        var voice = brief.sbBrief.getVoice();
        var files = [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }];
        if (sel.photo && photoInput) { files.push({ key: 'Photo', file: (photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null }); }
        var btn = sel.personalize ? submitBtn : nextBtn;
        var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        var errBox = sel.personalize ? err2 : err1;
        addItem(sel.vid, props, files)
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ btn.disabled = false; btn.textContent = orig; if (errBox) { errBox.textContent = 'Something went wrong adding to cart. Please try again.'; errBox.hidden = false; } });
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', function(){
          if (err2) { err2.hidden = true; }
          if (!briefOk()) { if (err2) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; } return; }
          var msg = brief.sbBrief.validate();
          if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          doAdd();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-sample-songs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.ss[data-section-id]').forEach(function (sec) {
      var cards = [].slice.call(sec.querySelectorAll('.ss-card'));
      var grid = sec.querySelector('.ss-grid');
      var empty = sec.querySelector('.ss-empty');

      // Build filter chips from the cards' categories
      var bar = sec.querySelector('.ss-filters');
      if (bar) {
        var cats = [];
        cards.forEach(function (c) {
          var v = (c.getAttribute('data-cat') || '').trim();
          if (v && cats.indexOf(v) === -1) cats.push(v);
        });
        if (cats.length > 1) {
          bar.hidden = false;
          ['All'].concat(cats).forEach(function (cat, i) {
            var b = document.createElement('button');
            b.className = 'ss-chip';
            b.type = 'button';
            b.textContent = cat;
            b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            b.addEventListener('click', function () {
              [].forEach.call(bar.children, function (x) { x.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              var shown = 0;
              cards.forEach(function (c) {
                var hit = cat === 'All' || c.getAttribute('data-cat') === cat;
                c.classList.toggle('is-hidden', !hit);
                if (hit) shown++;
              });
              if (empty) empty.hidden = shown > 0;
            });
            bar.appendChild(b);
          });
        }
      }

      // Players self-wire via snippets/song-player.liquid (play/pause/seek/progress,
      // and pausing other players when one starts — across all .sb-player on the page).
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pride-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.prd').forEach(function (root) {
      if (root.__prdWired) return;
      root.__prdWired = true;
      var cards = [].slice.call(root.querySelectorAll('.prd-card'));
      cards.forEach(function (card) {
        var a = card.querySelector('[data-prd-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-prd-play]');
        var prog = card.querySelector('.prd-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-article"] && !Shopify.designMode) return;
  try {
    
  /* Sticky bar only — the popup owns its own script, in the snippet.
     Shows once the inline pitch has scrolled past; hides again while the
     closing card is on screen, so the reader never sees two CTAs at once
     (Ajinkya, 2026-09-04: "it looks like 2 CTA's"). */
  (function () {
    var bar = document.querySelector('[data-sb-ar-sticky]');
    var anchor = document.querySelector('.sb-ar__pitch') || document.querySelector('.sb-ar__head');
    var end = document.querySelector('.sb-ar__end');
    if (!bar || !anchor) return;
    if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); return; }
    var past = false, ending = false;
    function sync() { if (past && !ending) bar.setAttribute('data-sb-show', ''); else bar.removeAttribute('data-sb-show'); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { past = !en.isIntersecting && en.boundingClientRect.top < 0; });
      sync();
    }, { threshold: 0 }).observe(anchor);
    if (end) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { ending = en.isIntersecting; });
        sync();
      }, { threshold: 0 }).observe(end);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-listen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var audio = root.querySelector('[data-sb-ls-audio]');
      var current = null;
      function stop() { if (!current) return; current.removeAttribute('data-sb-ls-playing'); current = null; try { audio.pause(); } catch (e) {} }
      root.querySelectorAll('[data-sb-ls-play]').forEach(function (btn) {
        var song = btn.closest('[data-sb-ls-song]');
        btn.addEventListener('click', function () {
          if (current === song) { stop(); return; }
          stop();
          audio.src = btn.getAttribute('data-src');
          var p = audio.play(); if (p && p.catch) p.catch(function () {});
          song.setAttribute('data-sb-ls-playing', ''); current = song;
        });
      });
      audio.addEventListener('ended', stop);

      root.querySelectorAll('[data-sb-ls-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var want = chip.getAttribute('data-sb-ls-chip');
          root.querySelectorAll('[data-sb-ls-chip]').forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          root.querySelectorAll('[data-sb-ls-song]').forEach(function (s) { s.hidden = !!want && s.getAttribute('data-style') !== want; });
        });
      });
    }
    document.querySelectorAll('.sb-ls').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-ls')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-open"] && !Shopify.designMode) return;
  try {
    
  /* sb-open — one phone, four gift pages. Every hold the photo crossfades and
     the text swaps; the bar runs the whole song length across one hold so it
     reads as playing. Reduced motion: first page, no cycling. Off screen: paused. */
  (function () {
    function boot(root) {
      var dataEl = root.querySelector('[data-sb-op-data]');
      var gifts = [];
      try { gifts = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { gifts = []; }
      var layers = [].slice.call(root.querySelectorAll('[data-sb-op-layer]'));
      var dots = [].slice.call(root.querySelectorAll('[data-sb-op-dot]'));
      var elFrom = root.querySelector('[data-sb-op-from]'), elTitle = root.querySelector('[data-sb-op-title]');
      var elMeta = root.querySelector('[data-sb-op-meta]'), elLine = root.querySelector('[data-sb-op-line]');
      var elBar = root.querySelector('[data-sb-op-bar]'), elEl = root.querySelector('[data-sb-op-elapsed]'), elLen = root.querySelector('[data-sb-op-length]');
      var hold = parseInt(root.getAttribute('data-hold'), 10) || 5000;
      var n = Math.min(gifts.length, layers.length);
      if (!n) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = 0, t0 = Date.now(), timer = null, visible = true, swapping = false;

      function toSecs(str) { var p = String(str || '').split(':'); if (p.length !== 2) return 180; return (parseInt(p[0], 10) || 0) * 60 + (parseInt(p[1], 10) || 0); }
      function fmt(sec) { sec = Math.max(0, Math.floor(sec)); var m = Math.floor(sec / 60), s = sec % 60; return m + ':' + (s < 10 ? '0' : '') + s; }

      function show(k, instant) {
        cur = k;
        layers.forEach(function (l, i) { l.classList.toggle('is-on', i === k); l.setAttribute('aria-hidden', i === k ? 'false' : 'true'); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); d.setAttribute('aria-selected', i === k ? 'true' : 'false'); });
        var g = gifts[k];
        var apply = function () {
          if (elFrom) elFrom.textContent = g.from || '';
          if (elTitle) elTitle.textContent = g.title || '';
          if (elMeta) elMeta.textContent = g.meta || '';
          if (elLine) elLine.textContent = g.line || '';
          if (elLen) elLen.textContent = g.length || '';
          root.classList.remove('is-swapping'); swapping = false;
        };
        if (instant || reduce) { apply(); return; }
        root.classList.add('is-swapping'); swapping = true;
        setTimeout(apply, 380);
      }

      function tick() {
        if (!visible) return;
        var el = (Date.now() - t0) % hold;             /* ms into this hold */
        var len = toSecs(gifts[cur].length);
        var secs = el / hold * len;                     /* the whole song across one hold */
        if (elBar) elBar.style.width = (secs / len * 100).toFixed(1) + '%';
        if (elEl) elEl.textContent = fmt(secs);
        var k = Math.floor((Date.now() - t0) / hold) % n;
        if (k !== cur && !swapping) show(k, false);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var k = parseInt(d.getAttribute('data-sb-op-dot'), 10) || 0;
          t0 = Date.now() - k * hold;                   /* align the clock so this page just started */
          show(k, false);
          if (elBar) elBar.style.width = '0%';
        });
      });

      if (reduce) { show(0, true); if (elBar) elBar.style.width = '35%'; if (elEl) elEl.textContent = fmt(toSecs(gifts[0].length) * 0.35); return; }

      function start() { if (timer) return; t0 = Date.now() - cur * hold; timer = setInterval(tick, 250); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = !!(es[0] && es[0].isIntersecting);
          if (visible) start(); else stop();
        }, { threshold: 0.2 }).observe(root);
      } else { start(); }
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (visible) start(); });
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-open]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-open]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-pdp"] && !Shopify.designMode) return;
  try {
    
  /* sb-pdp — offer choice, the Plaque gallery, the live ETA, and the
     deep-link out. NOTHING here adds to cart. The page's job is to hand the
     quiz a name, an occasion, a relationship and the chosen offer; the quiz
     collects the rest and the cart is built there.

     The closing CTA, objections and sticky bar live in the sb-pdp-close
     section (so Reviews can sit between them, as the artboard orders it), so
     every hook here is found on the DOCUMENT, not inside this section. */
  (function () {
    function boot(root) {
      var quiz = root.getAttribute('data-sb-quiz') || '/products/custom-song';
      var occasion = root.getAttribute('data-sb-occasion') || '';
      var rel = root.getAttribute('data-sb-rel') || '';
      var campaign = root.getAttribute('data-sb-campaign') || '';
      var cards = [].slice.call(root.querySelectorAll('[data-sb-offer]'));
      var offer = 'song-plaque';
      var q$ = function (sel) { return [].slice.call(document.querySelectorAll(sel)); };

      /* ── the live ETA: window.sbEta (snippets/songbond-head.liquid, ADR-072)
         → "tomorrow, 4pm" on the visitor's clock, rounded up. The Liquid
         prints "tomorrow" so the page reads right before this runs and with
         JS off. ── */
      var e = window.sbEta ? window.sbEta(24) : null;
      if (e) q$('[data-sb-eta]').forEach(function (el) {
        var v = e.text;
        if (el.getAttribute('data-sb-eta') === 'cap') v = v.charAt(0).toUpperCase() + v.slice(1);
        el.textContent = v;
      });
      if (e) q$('[data-sb-dateline]').forEach(function (el) {
        el.textContent = 'Song by ' + e.day + ' — play it on the day. The Plaque follows in 5–7 days (US & UK), 7–10 days elsewhere — the encore they keep.';
      });

      /* Forward whatever the visitor arrived with, so paid traffic keeps its
         attribution through the quiz and into the order. Only when NOTHING
         came in do we stamp the artboard's own source/medium/campaign
         (Ajinkya, 2026-09-04: "agree with you on UTM"). */
      function inbound() {
        var keep = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id',
                    'gclid','fbclid','ttclid','msclkid','ref'];
        var q = new URLSearchParams(window.location.search), out = [], anyUtm = false;
        keep.forEach(function (k) { var v = q.get(k); if (v) { out.push([k, v]); if (k.indexOf('utm_') === 0) anyUtm = true; } });
        if (!anyUtm) {
          out.push(['utm_source', 'songbond.com']);
          out.push(['utm_medium', 'intent-page']);
          if (campaign) out.push(['utm_campaign', campaign]);
        }
        return out;
      }

      function pick(next) {
        offer = next;
        cards.forEach(function (c) {
          var on = c.getAttribute('data-sb-offer') === next;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var chosen = root.querySelector('[data-sb-offer="' + next + '"]');
        if (!chosen) return;
        var p = chosen.querySelector('.sb-pdp__price'), t = chosen.querySelector('.sb-pdp__card-t');
        q$('[data-sb-sticky-price]').forEach(function (el) { if (p) el.textContent = p.textContent; });
        q$('[data-sb-sticky-meta]').forEach(function (el) { if (t) el.textContent = t.textContent; });
      }

      cards.forEach(function (c) {
        c.addEventListener('click', function () { pick(c.getAttribute('data-sb-offer')); });
        c.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); pick(c.getAttribute('data-sb-offer')); }
        });
      });

      function go(nameEl) {
        var name = '';
        if (nameEl && nameEl.value) { name = nameEl.value.trim(); }
        if (!name) {
          var any = q$('[data-sb-name]').filter(function (i) { return i.value && i.value.trim(); })[0];
          if (any) name = any.value.trim();
        }
        var q = new URLSearchParams();
        if (name) q.set('name', name);
        if (occasion) q.set('occasion', occasion);
        if (rel) q.set('rel', rel);
        q.set('offer', offer);
        /* step=2 only when we actually filled screen 1 for them. Sending an
           empty name to screen 2 strands the visitor on a form they never saw. */
        if (name) q.set('step', '2');
        inbound().forEach(function (kv) { q.set(kv[0], kv[1]); });
        window.location.href = quiz + '?' + q.toString();
      }

      q$('[data-sb-ask]').forEach(function (form) {
        if (form.__sb) return; form.__sb = true;
        form.addEventListener('submit', function (ev) { ev.preventDefault(); go(form.querySelector('[data-sb-name]')); });
      });
      q$('[data-sb-go]').forEach(function (btn) {
        if (btn.__sb) return; btn.__sb = true;
        btn.addEventListener('click', function (ev) {
          if (btn.tagName === 'A') ev.preventDefault();
          var forced = btn.getAttribute('data-sb-pick');
          if (forced) pick(forced);
          go(null);
        });
      });

      /* Plaque gallery */
      var main = root.querySelector('[data-sb-box-main]');
      [].forEach.call(root.querySelectorAll('[data-sb-box-thumb]'), function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-src');
          [].forEach.call(root.querySelectorAll('[data-sb-box-thumb]'), function (o) { o.classList.remove('is-on'); });
          t.classList.add('is-on');
        });
      });

      /* Sticky bar (in sb-pdp-close) — only once the hero's own button has scrolled away. */
      var bar = document.querySelector('[data-sb-sticky]');
      var anchor = root.querySelector('.sb-pdp__ask');
      if (bar && anchor) {
        if (!('IntersectionObserver' in window)) { bar.setAttribute('data-sb-show', ''); }
        else {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { bar.removeAttribute('data-sb-show'); }
              else if (en.boundingClientRect.top < 0) { bar.setAttribute('data-sb-show', ''); }
              else { bar.removeAttribute('data-sb-show'); }
            });
          }, { threshold: 0 }).observe(anchor);
        }
      }

      pick(offer);
    }
    function init() { document.querySelectorAll('.sb-pdp').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (ev) {
      var r = ev.target && ev.target.querySelector && (ev.target.querySelector('.sb-pdp') || document.querySelector('.sb-pdp'));
      if (r) boot(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var el = root.querySelector('[data-sb-pr-eta]');
      if (!el || !window.sbEta) return;
      el.textContent = window.sbEta(24).text;
    }
    document.querySelectorAll('.sb-pr').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-pr')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reactions"] && !Shopify.designMode) return;
  try {
    
  /* sb-reactions — one rail. In view = playing (muted); the pill or a tap
     gives ONE card its sound. Reduced motion = poster + play button. */
  (function () {
    function boot(root) {
      var rail = root.querySelector('[data-sb-rx-rail]');
      if (!rail) return;
      var cards = [].slice.call(root.querySelectorAll('[data-sb-rx-card]'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var onText = root.getAttribute('data-sound-on') || 'Sound on';
      var offText = root.getAttribute('data-sound-off') || 'Sound off';
      var loud = null;                         /* the one card with sound */
      /* how much of a card must be on screen before it plays: the standalone
         rail keeps 0.6; the hero passes 0.25 because its rail sits partly
         below the fold on phones and a still poster there looked broken
         (Ajinkya, 2026-09-23: "none of the videos on the homepage play") */
      var thr = parseFloat(root.getAttribute('data-sb-rx-threshold'));
      if (!(thr > 0 && thr < 1)) thr = 0.6;

      function video(c) { return c.querySelector('[data-sb-rx-video]'); }
      function pill(c) { return c.querySelector('[data-sb-rx-sound]'); }

      function setSound(c, on) {
        var v = video(c), b = pill(c), t = c.querySelector('[data-sb-rx-sound-t]');
        if (!v) return;
        v.muted = !on;
        if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on'); }
        if (t) t.textContent = on ? onText : offText;
        if (on) {
          if (loud && loud !== c) setSound(loud, false);
          loud = c;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (loud === c) { loud = null; }
      }

      function play(c) {
        var v = video(c); if (!v) return;
        var p = v.play();
        /* iOS Low Power Mode and some data-saver settings refuse programmatic
           play. Silently swallowing that left a frozen poster with nothing to
           tap — now the play button appears and one tap starts it. */
        if (p && p.catch) p.catch(function () { var pb = c.querySelector('[data-sb-rx-play]'); if (pb) pb.hidden = false; });
      }
      function pause(c) { var v = video(c); if (!v) return; v.pause(); if (loud === c) setSound(c, false); }

      cards.forEach(function (c) {
        var v = video(c), b = pill(c), pb = c.querySelector('[data-sb-rx-play]');
        if (!v) return;

        /* A missing transcoded asset falls back to the DEV placeholder, once. */
        var fb = v.getAttribute('data-sb-rx-fallback');
        if (fb && v.hasAttribute('data-sb-rx-asset')) {
          v.addEventListener('error', function onErr() {
            v.removeEventListener('error', onErr);
            var srcEl = v.querySelector('source'); if (srcEl) { srcEl.src = fb; v.load(); }
          }, true);
        }

        if (b) b.addEventListener('click', function (e) { e.stopPropagation(); setSound(c, v.muted); });
        c.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-sb-rx-sound],[data-sb-rx-play]')) return;
          if (reduce) { if (v.paused) { play(c); if (pb) pb.hidden = true; } else { v.pause(); if (pb) pb.hidden = false; } return; }
          setSound(c, v.muted);
        });
        if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); play(c); pb.hidden = true; });
        if (reduce && pb) pb.hidden = false;
      });

      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var c = en.target;
            if (en.isIntersecting && en.intersectionRatio >= thr) play(c); else pause(c);
          });
        }, { root: null, threshold: [0, thr] });
        cards.forEach(function (c) { io.observe(c); });
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(pause); });

      /* desktop arrows */
      var prev = root.querySelector('[data-sb-rx-prev]'), next = root.querySelector('[data-sb-rx-next]');
      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 320; }
      function edges() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (prev) prev.disabled = rail.scrollLeft <= 0;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
    }
    function init() { [].forEach.call(document.querySelectorAll('[data-sb-rx]'), boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-sb-rx]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sbRw) return; window.__sbRw = true;
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (!card || e.target.closest('a')) return;
      var row = card.closest('[data-sb-row]');
      var open = !card.classList.contains('is-open');
      if (row) row.querySelectorAll('[data-sb-card].is-open').forEach(function (c) { c.classList.remove('is-open'); });
      card.classList.toggle('is-open', open);
      if (row) row.classList.toggle('is-paused', open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('[data-sb-card]');
      if (card) { e.preventDefault(); card.click(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var rail = root.querySelector('[data-sb-ts-rail]'), dots = root.querySelector('[data-sb-ts-dots]');
      if (!rail || !dots) return;
      var ds = dots.querySelectorAll('span');
      rail.addEventListener('scroll', function () {
        var i = Math.round(rail.scrollLeft / (rail.firstElementChild.offsetWidth + 12));
        ds.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, { passive: true });
    }
    document.querySelectorAll('.sb-ts').forEach(boot);
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('.sb-ts')) boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["song-library"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.sgl').forEach(function (root) {
      if (root.__sglWired) return;
      root.__sglWired = true;
      var grid = root.querySelector('[data-sgl-grid]');
      var pills = root.querySelector('[data-sgl-pills]');
      var activePill = root.querySelector('[data-sgl-active-pill]');
      var browseBtn = root.querySelector('[data-sgl-browse]');
      var sheet = root.querySelector('[data-sgl-sheet]');
      var scrim = root.querySelector('[data-sgl-scrim]');
      var search = root.querySelector('[data-sgl-search]');
      var empty = root.querySelector('.sgl-empty');
      var xlink = root.querySelector('[data-sgl-xlink]');
      var cards = [].slice.call(root.querySelectorAll('.sgl-card'));
      var tiles = [].slice.call(root.querySelectorAll('[data-sgl-tile]'));
      var state = { occ: '', q: '' };
      var PRIMARY = {}, LABELS = {};
      [].forEach.call(pills ? pills.querySelectorAll('.sgl-pill') : [], function (b) {
        if (b === activePill) return;
        var k = b.getAttribute('data-occ');
        if (k) PRIMARY[k] = true;
      });
      tiles.forEach(function (t) {
        var nm = t.querySelector('.sgl-tile-name');
        LABELS[t.getAttribute('data-occ')] = nm ? nm.textContent : t.getAttribute('data-occ');
      });

      cards.forEach(function (card) {
        var a = card.querySelector('[data-sgl-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-sgl-play]');
        var prog = card.querySelector('.sgl-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });

      function apply() {
        var shown = 0;
        cards.forEach(function (card) {
          var okc = state.occ === '' || card.getAttribute('data-occ') === state.occ;
          var qc = state.q === '' || card.getAttribute('data-title').indexOf(state.q) !== -1;
          var ok = okc && qc;
          card.classList.toggle('is-hidden', !ok);
          if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      }
      function syncURL() {
        var params = new URLSearchParams();
        if (state.occ) params.set('occasion', state.occ);
        if (state.q) params.set('q', state.q);
        var qs = params.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
      }
      function openSheet() {
        if (!sheet) return;
        if (scrim) scrim.hidden = false;
        sheet.hidden = false;
        requestAnimationFrame(function () { sheet.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); });
        if (browseBtn) browseBtn.setAttribute('aria-expanded', 'true');
        if (window.matchMedia('(max-width:699px)').matches) document.body.style.overflow = 'hidden';
      }
      function closeSheet() {
        if (!sheet) return;
        sheet.classList.remove('is-open');
        if (scrim) scrim.classList.remove('is-open');
        if (browseBtn) browseBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () { sheet.hidden = true; if (scrim) scrim.hidden = true; }, 260);
      }
      function setOcc(occ) {
        state.occ = occ;
        if (pills) [].forEach.call(pills.querySelectorAll('.sgl-pill'), function (b) {
          if (b === activePill) return;
          b.setAttribute('aria-pressed', b.getAttribute('data-occ') === occ ? 'true' : 'false');
        });
        var isPrimary = occ === '' || PRIMARY[occ];
        if (activePill) {
          if (isPrimary) {
            activePill.hidden = true;
          } else {
            activePill.hidden = false;
            activePill.setAttribute('data-occ', occ);
            activePill.setAttribute('aria-pressed', 'true');
            activePill.innerHTML = (LABELS[occ] || occ) + ' <span class="sgl-pill-x" aria-hidden="true">×</span>';
          }
        }
        if (browseBtn) browseBtn.classList.toggle('is-active', !isPrimary);
        tiles.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-occ') === occ ? 'true' : 'false'); });
        if (xlink) xlink.hidden = occ !== 'pride';
        apply(); syncURL();
      }
      if (pills) pills.addEventListener('click', function (e) {
        var b = e.target.closest('.sgl-pill');
        if (!b) return;
        if (b === activePill) { setOcc(''); return; }
        setOcc(b.getAttribute('data-occ') || '');
      });
      tiles.forEach(function (t) {
        t.addEventListener('click', function () { setOcc(t.getAttribute('data-occ') || ''); closeSheet(); });
      });
      if (browseBtn) browseBtn.addEventListener('click', openSheet);
      if (scrim) scrim.addEventListener('click', closeSheet);
      var sheetX = root.querySelector('[data-sgl-sheet-x]');
      if (sheetX) sheetX.addEventListener('click', closeSheet);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });
      if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); apply(); syncURL(); });

      var p = new URLSearchParams(location.search);
      var o = (p.get('occasion') || '').toLowerCase();
      var q = p.get('q') || '';
      if (q) { state.q = q.toLowerCase(); if (search) search.value = q; }
      if (o && (PRIMARY[o] || LABELS[o])) setOcc(o);
      else apply();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["song-page"]) return;
  try {
    
(function () {
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var m = Math.floor(s / 60), x = s % 60; return m + ':' + (x < 10 ? '0' : '') + x; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function init() {
    document.querySelectorAll('.sgp').forEach(function (root) {
      if (root.__sgpWired) return;
      root.__sgpWired = true;
      var audio = root.querySelector('[data-sgp-audio]');
      var np = root.querySelector('.sgp-np');
      var mini = root.querySelector('[data-sgp-mini]');
      var bar = root.querySelector('[data-sgp-bar]');
      var scrub = root.querySelector('[data-sgp-scrub]');
      var curEl = root.querySelector('[data-sgp-cur]');
      var durEl = root.querySelector('[data-sgp-dur]');
      if (!audio) return;
      function paint(p) { p = clamp(p, 0, 1); if (scrub) { scrub.style.setProperty('--p', (p * 100).toFixed(2) + '%'); scrub.setAttribute('aria-valuenow', String(Math.round(p * 100))); } }
      function toggle() { if (audio.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== audio) o.pause(); }); audio.play().catch(function () {}); } else { audio.pause(); } }
      root.querySelectorAll('[data-sgp-play]').forEach(function (b) { b.addEventListener('click', toggle); });
      var restart = root.querySelector('[data-sgp-restart]');
      if (restart) restart.addEventListener('click', function () { audio.currentTime = 0; audio.play().catch(function () {}); });
      var repeat = root.querySelector('[data-sgp-repeat]');
      if (repeat) repeat.addEventListener('click', function () { audio.loop = !audio.loop; repeat.setAttribute('aria-pressed', audio.loop ? 'true' : 'false'); });
      audio.addEventListener('play', function () { root.classList.add('sgp-playing'); });
      audio.addEventListener('pause', function () { root.classList.remove('sgp-playing'); });
      audio.addEventListener('ended', function () { paint(0); if (curEl) curEl.textContent = '0:00'; });
      audio.addEventListener('loadedmetadata', function () { if (durEl && isFinite(audio.duration)) durEl.textContent = fmt(audio.duration); });
      audio.addEventListener('timeupdate', function () { var d = audio.duration || 0; paint(d ? audio.currentTime / d : 0); if (curEl) curEl.textContent = fmt(audio.currentTime); });
      if (scrub) {
        var seek = function (x) { var r = scrub.getBoundingClientRect(); var f = clamp((x - r.left) / r.width, 0, 1); if (isFinite(audio.duration) && audio.duration) { audio.currentTime = f * audio.duration; paint(f); if (curEl) curEl.textContent = fmt(audio.currentTime); } };
        var drag = false;
        scrub.addEventListener('pointerdown', function (e) { drag = true; try { scrub.setPointerCapture(e.pointerId); } catch (err) {} seek(e.clientX); });
        scrub.addEventListener('pointermove', function (e) { if (drag) seek(e.clientX); });
        scrub.addEventListener('pointerup', function () { drag = false; });
        scrub.addEventListener('pointercancel', function () { drag = false; });
        scrub.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration); }
          else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
        });
      }
      paint(0);
      if (np && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (bar) bar.classList.toggle('sgp-solid', !en.isIntersecting);
            if (mini) mini.classList.toggle('sgp-show', !en.isIntersecting);
          });
        }, { rootMargin: '-70px 0px 0px 0px', threshold: 0 }).observe(np);
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
